"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WindowManager;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _WindowManagerModule = _interopRequireDefault(require("./WindowManager.module.scss"));

var _WindowManagerContext = _interopRequireDefault(require("../WindowManagerContext/WindowManagerContext"));

var _mockedManagedWindows = _interopRequireDefault(require("./mockedManagedWindows"));

var _InventoryWindow = _interopRequireDefault(require("../items/InventoryWindow/InventoryWindow"));

var _item = _interopRequireDefault(require("../../../mocks/item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BASE_ZINDEX_TODO = 0; // TODO: IMPORTANT !!!!!! should never exceed ZINDEX_MODAL or ZINDEX_MOUSE_TOOLTIP (zIndexes.scss)

function WindowManager(_ref) {
  var _ref$baseZIndex = _ref.baseZIndex,
      baseZIndex = _ref$baseZIndex === void 0 ? BASE_ZINDEX_TODO : _ref$baseZIndex,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useContext = (0, _react.useContext)(_WindowManagerContext.default),
      windows = _useContext.windows,
      openWindow = _useContext.openWindow,
      openWindows = _useContext.openWindows,
      focusWindow = _useContext.focusWindow,
      clean = _useContext.clean;

  var testButtons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    style: {
      position: "absolute",
      left: "200px"
    },
    onClick: function onClick() {
      openWindows(_mockedManagedWindows.default.map(function (entry) {
        var component = entry.component,
            posX = entry.posX,
            posY = entry.posY;
        return {
          component: component,
          posX: posX,
          posY: posY
        };
      }));
    }
  }, "Open multiple windows"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      openWindow({
        component: /*#__PURE__*/_react.default.createElement(_InventoryWindow.default, {
          itemPool: {
            sizeX: 7,
            sizeY: 6,
            items: [_item.default]
          }
        })
      });
    },
    style: {
      position: "absolute",
      left: "400px"
    }
  }, "Open single window"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: clean,
    style: {
      position: "absolute",
      left: "600px"
    }
  }, "Clean up"));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_WindowManagerModule.default.windowManager, "windowDragBoundary", className),
    style: style
  }, testButtons, windows.map(function (window) {
    var id = window.id,
        posX = window.posX,
        posY = window.posY,
        posZ = window.posZ,
        component = window.component;
    return /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
      key: id,
      bounds: ".windowDragBoundary",
      handle: ".windowDragHandler",
      defaultPosition: {
        x: posX,
        y: posY
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _WindowManagerModule.default.windowWrapper,
      "data-windowid": id,
      onMouseDownCapture: function onMouseDownCapture() {
        focusWindow(id);
      },
      style: {
        zIndex: baseZIndex + posZ
      }
    }, component));
  }));
}